import 'lazysizes';
import 'css/responsive/blog-display.scss';
import 'js/shared/common/common.fn.js';